// components/NativeScreenTitle.js
//
// Titel van het huidige scherm in de app (telefoon): altijd gecentreerd bovenaan,
// op dezelfde plek voor admin, verhuurder en schoonmaker. Wordt in de bovenste
// navigatiebalk geplaatst; de losse titels in de schermen zelf zijn in de app
// verborgen (zie appTheme.css).
import React from 'react';

function NativeScreenTitle({ title }) {
  if (!title) return null;
  return <h1 className="native-screen-heading">{title}</h1>;
}

export default NativeScreenTitle;
